module.exports = __webpack_public_path__ + "static/media/logo.f78e5205.png";